<template>
  <div>
    <!--    <note>
          Text content for QRCode
        </note>-->
    <!--    <input v-model="text" type="text"/>-->
    <img v-if="text" class="mt-6 mb-2 rounded border" :src="qrcode" alt="QR Code">
  </div>
</template>

<script>
import {ref} from 'vue'
import {useQRCode} from '@vueuse/integrations/useQRCode'

/*const props = defineProps(['textValue'])
const text = ref(props.textValue)*/

export default {
  name:     'ks-document-wrapper',
  props:    {
    textValue: {
      type: String,
    },
  },
  methods:  {
    getQrCode(text) {
      let _this = this;
      return new Promise((resolve) => {
        _this.text   = text;
        if (this.consoleLogs) console.log("_this.text", _this.text)
        _this.qrcode = useQRCode(_this.text, {
          errorCorrectionLevel: 'H',
          margin:               3,
        });
        setTimeout(() => resolve(_this.qrcode), 300);
      });
    }
  },
  computed: {
    // qrCode: this.qrcode
  },
  data:     function () {
    return {
      text:   ref(this.textValue),
      qrcode: null
    }
  },
  mounted() {
    this.qrcode = useQRCode(this.text, {
      errorCorrectionLevel: 'H',
      margin:               3,
    })
  }
}

</script>



